// React
import React, { useState, useEffect } from "react";

// Bootstrap
import { Modal, Button, Input, Radio } from "antd";

// Components
import ListSelectionTypeahead from "../components/ListSelectionTypeahead";
import ListTable from "../components/ListTable";

// Libs
import * as EventifyAPI from "../libs/EventifyAPI";
import * as ModelCache from "../libs/ModelCache";

// AWS
import { Auth } from "aws-amplify";
import { setSeconds } from "date-fns";

// UUID
const uuidv4 = require("uuid/v4");

const ListOperationTypes = {
  join: "join",
  intersection: "intersection",
  aButNotB: "aButNotB",
  bButNotA: "bButNotA"
};

const ListSortFunction = {
  updated: {
    ascending: "updated_asc",
    descending: "updated_desc"
  },
  alphabetical: {
    ascending: "alpha_asc",
    descending: "alpha_desc"
  }
};

const ListCompareModal = React.forwardRef((props, ref) => {
  const targetListId = props.listId;

  const [isLoading, setIsLoading] = useState(false);
  const [listA, setListA] = useState({});
  const [listB, setListB] = useState({});
  const [operationType, setOperationType] = useState(ListOperationTypes.join);
  const [reloadProtocol, setReloadProtocol] = useState(null);
  const [finalList, setFinalList] = useState([]);
  const [addRemoveMap, setAddRemoveMap] = useState({}); // map of personid -> command
  const [selectedSortFunction, setSelectedSortFunction] = useState(
    ListSortFunction.alphabetical.descending
  );
  const [hasSelectedListA, setHasSelectedListA] = useState(false);
  const [defaultSelectedListA, setDefaultSelectedListA] = useState([]);
  const [leftOutList, setLeftOutList] = useState([]);
  const [listAMap, setListAMap] = useState({});
  const [listBMap, setListBMap] = useState({});

  // Allow hierarchy to call functions on this component
  // the ref might not actually be necessary
  const modalComponentRef = React.useRef();
  const listUploaderModalRef = React.useRef();
  const listATypeaheadRef = React.useRef();
  const listBTypeaheadRef = React.useRef();

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    if (targetListId != null) {
      fetchListWithId(targetListId, "A");
    }
  }

  function validateForm() {
    // return fields.email.length > 0 && fields.password.length > 0;
    return true;
  }

  // TODO: remove this functionality
  function uploadCSVAction() {
    if (listUploaderModalRef.current != null) {
      // onOk();
      listUploaderModalRef.current.handleShowImperative(); // you can access child method here
    }
  }

  async function handleSubmit(event) {
    event.preventDefault();

    setIsLoading(true);
  }

  async function fetchListWithId(listid, whichList) {
    ModelCache.getMembershipForListId(
      listid,
      result => {
        if (typeof result !== "undefined") {
          handleListResponse(result, listid, whichList);
        }
      }
    );
    ModelCache.getListForId(
      listid,
      result => {
        handleListInformation(result, listid, whichList);
      }
    );
  }

  function handleListInformation(result, listid, whichList) {
    if (whichList === "A") {
      setDefaultSelectedListA([result]);
      setHasSelectedListA(true);
      setReloadProtocol(uuidv4());
    } else if (whichList === "B") {
      // setListB(result);
      // setReloadProtocol(uuidv4());
    }
    // setStateListName(result.name);
    //
    // const list = result;
    // if (typeof list !== "undefined") {
    //   getListCreator(list.userid);
    //
    //   if (listTableRef.current != null) {
    //     console.log(listid);
    //     listTableRef.current.setCurrentListId(listid);
    //   }
    //
    //   if (typeof list.primaryDate !== "undefined") {
    //     setPrimaryListDate(new Date(list.primaryDate));
    //   }
    //
    //   setReloadProtocol(uuidv4());
    // }
  }

  function handleListResponse(result, listid, whichList) {
    if (whichList === "A") {
      setListA(result);
      applyListOperation(result, listB, operationType);
    } else if (whichList === "B") {
      setListB(result);
      applyListOperation(listA, result, operationType);
    }

    setReloadProtocol(uuidv4());
  }

  function applyListOperation(leftList, rightList, operation) {
    var newFinalCommandMap = {};
    var localList = [];
    var localLeftOutLocalList = [];

    var localListAMap = {};
    var localListBMap = {};

    for (var k=0; k<leftList.length; k++) {
      localListAMap[leftList[k].personid] = leftList[k];
    }

    for (var k=0; k<rightList.length; k++) {
      localListBMap[rightList[k].personid] = rightList[k];
    }

    if (operation === ListOperationTypes.join) {
      var existMap = {};
      for (var k = 0; k < leftList.length; k++) {
        localList.push(leftList[k]);
        existMap[leftList[k].personid] = leftList[k];
      }
      for (var k = 0; k < rightList.length; k++) {
        const existCheck = existMap[rightList[k].personid];
        if (existCheck == null || typeof existCheck === "undefined") {
          localList.push(rightList[k]);
          newFinalCommandMap[rightList[k].personid] = "add";
        }
      }
    } else if (operation === ListOperationTypes.intersection) {
      var existMap = {};
      for (var k = 0; k < leftList.length; k++) {
        const entryA = leftList[k];
        var foundIntersection = false;
        for (var q = 0; q < rightList.length; q++) {
          const entryB = rightList[q];
          if (entryA.personid === entryB.personid) {
            existMap[entryA.personid] = entryA;
            localList.push(entryA);
            newFinalCommandMap[entryA.personid] = "keep";
            foundIntersection = true;
            break;
          }
        }
        if (!foundIntersection) {
          localLeftOutLocalList.push(entryA);
          newFinalCommandMap[entryA.personid] = "remove";
        }
      }
    } else if (operation === ListOperationTypes.aButNotB) {
      var existMap = {};
      for (var k = 0; k < leftList.length; k++) {
        const entryA = leftList[k];
        var foundInListB = false;
        for (var q = 0; q < rightList.length; q++) {
          const entryB = rightList[q];
          if (entryA.personid === entryB.personid) {
            foundInListB = true;
            break;
          }
        }
        if (!foundInListB) {
          localList.push(entryA);
        } else {
          localLeftOutLocalList.push(entryA)
          newFinalCommandMap[entryA.personid] = "remove";
        }
      }
    }

    setListAMap(localListAMap);
    setListBMap(localListBMap);

    const leftOutSorted = applySortToMembershipList(localLeftOutLocalList, selectedSortFunction);
    setLeftOutList(leftOutSorted);

    const sorted = applySortToMembershipList(localList, selectedSortFunction);
    setFinalList(sorted);
    setAddRemoveMap(newFinalCommandMap);
  }

  function applySortToMembershipList(persons, sortFunction) {
    var localPersons = persons;
    var fn = null;
    if (sortFunction === ListSortFunction.updated.ascending) {
      fn = (a, b) => {
        return a.membership.updated > b.membership.updated ? -1 : 1;
      };
    } else if (sortFunction === ListSortFunction.updated.descending) {
      fn = (a, b) => {
        return a.membership.updated < b.membership.updated ? -1 : 1;
      };
    } else if (sortFunction === ListSortFunction.alphabetical.ascending) {
      fn = (a, b) => {
        return a.name > b.name ? -1 : 1;
      };
    } else if (sortFunction === ListSortFunction.alphabetical.descending) {
      fn = (a, b) => {
        return a.name < b.name ? -1 : 1;
      };
    }
    localPersons.sort(fn);
    return localPersons;
  }

  async function addItems() {
    if (selectedTabKey == "contact") {
      const selectedIndividualContacts = selectedPersons;
      // const result = await EventifyAPI.addRemovePersonsToList(props.email, currentListId, selectedIndividualContacts, true);
    } else if (selectedTabKey == "list") {
      const listidsonly = selectedLists.map((item, n) => {
        return item.listid;
      });
      for (var k = 0; k < listidsonly.length; k++) {
        const listid = listidsonly[k];
        const result = await EventifyAPI.addListToList(
          targetListId,
          listid
        );
      }
    }
    window.location.reload();
  }

  async function removeItems() {
    if (selectedTabKey == "contact") {
      const selectedIndividualContacts = selectedPersons;
      // const result = await EventifyAPI.addRemovePersonsToList(props.email, currentListId, selectedIndividualContacts, false);
    } else if (selectedTabKey == "list") {
      const listidsonly = selectedLists.map((item, n) => {
        return item.listid;
      });
      // const result = await EventifyAPI.addRemoveListsToList(props.email, currentListId, listidsonly, false);
    }
    window.location.reload();
  }

  var selectedLists = [];
  async function onUpdateListSelection(selected) {
    selectedLists = selected;
  }

  var selectedPersons = [];
  async function onUpdatePersonSelection(selected) {
    selectedPersons = selected;
  }

  var selectedTabKey = "list";
  function selectedTab(tabKey) {
    selectedTabKey = tabKey;
  }

  function onInputChange(value) {}

  function inListAlready(personid) {
    return false;
  }

  function onOk() {
    // do something

    // then close
    if (props.onOk) {
      props.onOk();
    } else {
      props.onCancel();
    }
  }

  function onCancel() {
    // then close
    props.onCancel()
  }

  var selectedLists = [];
  async function onUpdateListASelection(selected) {
    if (selected.length > 0) {
      fetchListWithId(selected[0].listid, "A");
    }
  }

  async function onUpdateListBSelection(selected) {
    console.log(selected);
    if (selected.length > 0) {
      fetchListWithId(selected[0].listid, "B");
    }
  }

  function renderListATypeahead() {
    return (
      <>
        {" "}
        {hasSelectedListA === true ? (
          <ListSelectionTypeahead
            id="listA"
            ref={listATypeaheadRef}
            onUpdate={onUpdateListASelection}
            email={props.email}
            organizationid={props.organizationid}
            multiple={false}
            selectedDefaults={defaultSelectedListA}
          />
        ) : (
          <></>
        )}{" "}
      </>
    );
  }

  function renderListBTypeahead() {
    return (
      <ListSelectionTypeahead
        id="listB"
        ref={listBTypeaheadRef}
        onUpdate={onUpdateListBSelection}
        email={props.email}
        organizationid={props.organizationid}
        multiple={false}
      />
    );
  }

  function onListOperationTypeSelectionChange(event) {
    console.log(event.target.value);

    setOperationType(event.target.value);

    applyListOperation(listA, listB, event.target.value);

    setReloadProtocol(uuidv4());
  }

  return (
    <Modal
      visible={props.visible}
      title={"Select lists to compare"}
      onOk={onOk}
      onCancel={onCancel}
      animation={true}
      className="list-compare-modal"
      footer={[
        <Button type="primary" onClick={addItems}>
          Finish
        </Button>
      ]}
    >
      <div className="compare-modal-content-container">
        <div className="column col-left">
          <div className="column-content">
            <h4>Compare</h4>
            {renderListATypeahead()}
          </div>
          <div className="column-content">
            <h4>With</h4>
            {renderListBTypeahead()}
          </div>
          <div className="column-content">
            <Radio.Group
              defaultValue={ListOperationTypes.join}
              size="large"
              onChange={onListOperationTypeSelectionChange}
            >
              <Radio.Button value={ListOperationTypes.join}>
                <svg
                  width="32"
                  height="22"
                  viewBox="0 0 32 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="style-when-active-body"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 2.33782C13.011 4.06687 11 7.29859 11 11C11 14.7014 13.011 17.9331 16 19.6622C14.5291 20.513 12.8214 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C12.8214 1 14.5291 1.48697 16 2.33782Z"
                    stroke="white"
                  />
                  <path
                    className="style-when-active-body"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 19.6622C18.989 17.9331 21 14.7014 21 11C21 7.29859 18.989 4.06687 16 2.33782C17.4709 1.48697 19.1786 1 21 1C26.5228 1 31 5.47715 31 11C31 16.5228 26.5228 21 21 21C19.1786 21 17.4709 20.513 16 19.6622Z"
                    stroke="white"
                  />
                  <path
                    className="style-when-active-body"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 2.33783C18.989 4.06688 21 7.2986 21 11C21 14.7014 18.989 17.9331 16 19.6622C13.011 17.9331 11 14.7014 11 11C11 7.2986 13.011 4.06688 16 2.33783Z"
                    stroke="white"
                  />
                  <path
                    className="style-when-active-text"
                    d="M7.96781 14L7.47781 12.558H5.50381L5.01381 14H4.41881L6.12681 9.114H6.87581L8.58381 14H7.96781ZM6.50481 9.66H6.46981L5.64381 12.04H7.33081L6.50481 9.66Z"
                  />
                  <path
                    className="style-when-active-text"
                    d="M23.8644 9.114H25.8734C26.2794 9.114 26.5967 9.22833 26.8254 9.457C27.0587 9.68567 27.1754 9.99133 27.1754 10.374C27.1754 10.556 27.1497 10.71 27.0984 10.836C27.047 10.962 26.9817 11.067 26.9024 11.151C26.823 11.2303 26.7367 11.291 26.6434 11.333C26.55 11.3703 26.4637 11.396 26.3844 11.41V11.452C26.473 11.4567 26.571 11.48 26.6784 11.522C26.7904 11.564 26.8954 11.6317 26.9934 11.725C27.0914 11.8137 27.173 11.9303 27.2384 12.075C27.3084 12.215 27.3434 12.3853 27.3434 12.586C27.3434 12.7867 27.3107 12.9733 27.2454 13.146C27.1847 13.3187 27.0984 13.468 26.9864 13.594C26.8744 13.72 26.7414 13.8203 26.5874 13.895C26.4334 13.965 26.2654 14 26.0834 14H23.8644V9.114ZM24.4524 13.482H25.9014C26.1534 13.482 26.3517 13.419 26.4964 13.293C26.641 13.1623 26.7134 12.9733 26.7134 12.726V12.488C26.7134 12.2407 26.641 12.054 26.4964 11.928C26.3517 11.7973 26.1534 11.732 25.9014 11.732H24.4524V13.482ZM24.4524 11.228H25.8034C26.0367 11.228 26.2187 11.1697 26.3494 11.053C26.48 10.9363 26.5454 10.7683 26.5454 10.549V10.311C26.5454 10.0917 26.48 9.92367 26.3494 9.807C26.2187 9.69033 26.0367 9.632 25.8034 9.632H24.4524V11.228Z"
                  />
                </svg>
              </Radio.Button>
              <Radio.Button value={ListOperationTypes.intersection}>
                {" "}
                <svg
                  width="32"
                  height="22"
                  viewBox="0 0 32 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 2.33782C13.011 4.06687 11 7.29859 11 11C11 14.7014 13.011 17.9331 16 19.6622C14.5291 20.513 12.8214 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C12.8214 1 14.5291 1.48697 16 2.33782Z"
                    fill="#E0E9F6"
                    stroke="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 19.6622C18.989 17.9331 21 14.7014 21 11C21 7.29859 18.989 4.06687 16 2.33782C17.4709 1.48697 19.1786 1 21 1C26.5228 1 31 5.47715 31 11C31 16.5228 26.5228 21 21 21C19.1786 21 17.4709 20.513 16 19.6622Z"
                    fill="#E0E9F6"
                    stroke="white"
                  />
                  <path
                    className="style-when-active-body"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 2.33783C18.989 4.06688 21 7.2986 21 11C21 14.7014 18.989 17.9331 16 19.6622C13.011 17.9331 11 14.7014 11 11C11 7.2986 13.011 4.06688 16 2.33783Z"
                    stroke="white"
                  />
                  <path
                    className="style-when-active-text"
                    d="M23.8644 9.114H25.8734C26.2794 9.114 26.5967 9.22833 26.8254 9.457C27.0587 9.68567 27.1754 9.99133 27.1754 10.374C27.1754 10.556 27.1497 10.71 27.0984 10.836C27.047 10.962 26.9817 11.067 26.9024 11.151C26.823 11.2303 26.7367 11.291 26.6434 11.333C26.55 11.3703 26.4637 11.396 26.3844 11.41V11.452C26.473 11.4567 26.571 11.48 26.6784 11.522C26.7904 11.564 26.8954 11.6317 26.9934 11.725C27.0914 11.8137 27.173 11.9303 27.2384 12.075C27.3084 12.215 27.3434 12.3853 27.3434 12.586C27.3434 12.7867 27.3107 12.9733 27.2454 13.146C27.1847 13.3187 27.0984 13.468 26.9864 13.594C26.8744 13.72 26.7414 13.8203 26.5874 13.895C26.4334 13.965 26.2654 14 26.0834 14H23.8644V9.114ZM24.4524 13.482H25.9014C26.1534 13.482 26.3517 13.419 26.4964 13.293C26.641 13.1623 26.7134 12.9733 26.7134 12.726V12.488C26.7134 12.2407 26.641 12.054 26.4964 11.928C26.3517 11.7973 26.1534 11.732 25.9014 11.732H24.4524V13.482ZM24.4524 11.228H25.8034C26.0367 11.228 26.2187 11.1697 26.3494 11.053C26.48 10.9363 26.5454 10.7683 26.5454 10.549V10.311C26.5454 10.0917 26.48 9.92367 26.3494 9.807C26.2187 9.69033 26.0367 9.632 25.8034 9.632H24.4524V11.228Z"
                  />
                  <path
                    className="style-when-active-text"
                    d="M7.96781 14L7.47781 12.558H5.50381L5.01381 14H4.41881L6.12681 9.114H6.87581L8.58381 14H7.96781ZM6.50481 9.66H6.46981L5.64381 12.04H7.33081L6.50481 9.66Z"
                  />
                </svg>
              </Radio.Button>
              <Radio.Button value={ListOperationTypes.aButNotB}>
                {" "}
                <svg
                  width="32"
                  height="22"
                  viewBox="0 0 32 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="style-when-active-body"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 2.33782C13.011 4.06687 11 7.29859 11 11C11 14.7014 13.011 17.9331 16 19.6622C14.5291 20.513 12.8214 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C12.8214 1 14.5291 1.48697 16 2.33782Z"
                    stroke="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 19.6622C18.989 17.9331 21 14.7014 21 11C21 7.29859 18.989 4.06687 16 2.33782C17.4709 1.48697 19.1786 1 21 1C26.5228 1 31 5.47715 31 11C31 16.5228 26.5228 21 21 21C19.1786 21 17.4709 20.513 16 19.6622Z"
                    fill="#E0E9F6"
                    stroke="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.0001 2.33783C18.9891 4.06688 21.0001 7.2986 21.0001 11C21.0001 14.7014 18.9891 17.9331 16.0001 19.6622C13.0111 17.9331 11.0001 14.7014 11.0001 11C11.0001 7.2986 13.0111 4.06688 16.0001 2.33783Z"
                    fill="#E0E9F6"
                    stroke="white"
                  />
                  <path
                    className="style-when-active-text"
                    d="M7.96781 14L7.47781 12.558H5.50381L5.01381 14H4.41881L6.12681 9.114H6.87581L8.58381 14H7.96781ZM6.50481 9.66H6.46981L5.64381 12.04H7.33081L6.50481 9.66Z"
                  />
                  <path
                    className="style-when-active-text"
                    d="M23.8644 9.114H25.8734C26.2794 9.114 26.5967 9.22833 26.8254 9.457C27.0587 9.68567 27.1754 9.99133 27.1754 10.374C27.1754 10.556 27.1497 10.71 27.0984 10.836C27.047 10.962 26.9817 11.067 26.9024 11.151C26.823 11.2303 26.7367 11.291 26.6434 11.333C26.55 11.3703 26.4637 11.396 26.3844 11.41V11.452C26.473 11.4567 26.571 11.48 26.6784 11.522C26.7904 11.564 26.8954 11.6317 26.9934 11.725C27.0914 11.8137 27.173 11.9303 27.2384 12.075C27.3084 12.215 27.3434 12.3853 27.3434 12.586C27.3434 12.7867 27.3107 12.9733 27.2454 13.146C27.1847 13.3187 27.0984 13.468 26.9864 13.594C26.8744 13.72 26.7414 13.8203 26.5874 13.895C26.4334 13.965 26.2654 14 26.0834 14H23.8644V9.114ZM24.4524 13.482H25.9014C26.1534 13.482 26.3517 13.419 26.4964 13.293C26.641 13.1623 26.7134 12.9733 26.7134 12.726V12.488C26.7134 12.2407 26.641 12.054 26.4964 11.928C26.3517 11.7973 26.1534 11.732 25.9014 11.732H24.4524V13.482ZM24.4524 11.228H25.8034C26.0367 11.228 26.2187 11.1697 26.3494 11.053C26.48 10.9363 26.5454 10.7683 26.5454 10.549V10.311C26.5454 10.0917 26.48 9.92367 26.3494 9.807C26.2187 9.69033 26.0367 9.632 25.8034 9.632H24.4524V11.228Z"
                  />
                </svg>
              </Radio.Button>
              <Radio.Button value={ListOperationTypes.bButNotA}>
                {" "}
                <svg
                  width="32"
                  height="22"
                  viewBox="0 0 32 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 2.33782C13.011 4.06687 11 7.29859 11 11C11 14.7014 13.011 17.9331 16 19.6622C14.5291 20.513 12.8214 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C12.8214 1 14.5291 1.48697 16 2.33782Z"
                    fill="#E0E9F6"
                    stroke="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.0001 2.33783C18.9891 4.06688 21.0001 7.2986 21.0001 11C21.0001 14.7014 18.9891 17.9331 16.0001 19.6622C13.0111 17.9331 11.0001 14.7014 11.0001 11C11.0001 7.2986 13.0111 4.06688 16.0001 2.33783Z"
                    fill="#E0E9F6"
                    stroke="white"
                  />
                  <path
                    className="style-when-active-body"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 19.6622C18.989 17.9331 21 14.7014 21 11C21 7.29859 18.989 4.06687 16 2.33782C17.4709 1.48697 19.1786 1 21 1C26.5228 1 31 5.47715 31 11C31 16.5228 26.5228 21 21 21C19.1786 21 17.4709 20.513 16 19.6622Z"
                    fill="#BEC8D6"
                    stroke="white"
                  />
                  <path
                    className="style-when-active-text"
                    d="M22.8644 9.114H24.8734C25.2794 9.114 25.5967 9.22833 25.8254 9.457C26.0587 9.68567 26.1754 9.99133 26.1754 10.374C26.1754 10.556 26.1497 10.71 26.0984 10.836C26.047 10.962 25.9817 11.067 25.9024 11.151C25.823 11.2303 25.7367 11.291 25.6434 11.333C25.55 11.3703 25.4637 11.396 25.3844 11.41V11.452C25.473 11.4567 25.571 11.48 25.6784 11.522C25.7904 11.564 25.8954 11.6317 25.9934 11.725C26.0914 11.8137 26.173 11.9303 26.2384 12.075C26.3084 12.215 26.3434 12.3853 26.3434 12.586C26.3434 12.7867 26.3107 12.9733 26.2454 13.146C26.1847 13.3187 26.0984 13.468 25.9864 13.594C25.8744 13.72 25.7414 13.8203 25.5874 13.895C25.4334 13.965 25.2654 14 25.0834 14H22.8644V9.114ZM23.4524 13.482H24.9014C25.1534 13.482 25.3517 13.419 25.4964 13.293C25.641 13.1623 25.7134 12.9733 25.7134 12.726V12.488C25.7134 12.2407 25.641 12.054 25.4964 11.928C25.3517 11.7973 25.1534 11.732 24.9014 11.732H23.4524V13.482ZM23.4524 11.228H24.8034C25.0367 11.228 25.2187 11.1697 25.3494 11.053C25.48 10.9363 25.5454 10.7683 25.5454 10.549V10.311C25.5454 10.0917 25.48 9.92367 25.3494 9.807C25.2187 9.69033 25.0367 9.632 24.8034 9.632H23.4524V11.228Z"
                  />
                  <path
                    className="style-when-active-text"
                    d="M7.96781 14L7.47781 12.558H5.50381L5.01381 14H4.41881L6.12681 9.114H6.87581L8.58381 14H7.96781ZM6.50481 9.66H6.46981L5.64381 12.04H7.33081L6.50481 9.66Z"
                  />
                </svg>
              </Radio.Button>
            </Radio.Group>
          </div>
          <p>
            {finalList.length} contacts in the final list, {leftOutList.length} contact{leftOutList.length != 1 ? "s" : ""} removed.
          </p>
          <div className="column-content">
            <Button disabled>New list with selection</Button>
            <Button type="primary" disabled>Add selection to list</Button>
          </div>
        </div>
        <div className="column col-right">
          <h4>Result</h4>
          <ul>
            {finalList.map((row, n) => (
              <li
                className={`modal-contact ${
                  addRemoveMap[row.personid] === "add" ? "addColor" : ""
                } ${
                  addRemoveMap[row.personid] === "remove" ? "removeColor" : ""
                }`}
              >
                <p className="modal-contact-name">{row.name}</p>
                <p className="modal-contact-email">{row.email}</p>
                <p className="modal-contact-list">{listAMap[row.personid] != null ? "A " : "" } {listBMap[row.personid] != null ? "B" : "" }</p>
              </li>
            ))}
            {leftOutList.map((row, n) => (
              <li className={`modal-contact ${ addRemoveMap[row.personid] === "add" ? "addColor" : "" } ${ addRemoveMap[row.personid] === "remove" ? "removeColor" : "" }`}>
                <p className="modal-contact-name">{row.name}</p>
                <p className="modal-contact-email">{row.email}</p>
                <p className="modal-contact-list">{listAMap[row.personid] != null ? "A " : "" } {listBMap[row.personid] != null ? "B" : "" }</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Modal>
  );
});
export default ListCompareModal;
